export default __webpack_public_path__ + "74c30bebfda5f4d8b3722c45e61f54cc.svg";